export default function ResultsIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 512 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M256 48C141.12 48 48 141.12 48 256s93.12 208 208 208c107.2 0 195.44-81.12 206.72-185.28H256V48z" />
      <path d="M288 48.64V224h175.36C450.4 134.88 377.12 61.6 288 48.64z" />
    </svg>
  );
}
